export default class ContentStackCard extends HTMLElement {
    constructor() {
        super();
    }
}

window.customElements.define('nc-content-stack-card', ContentStackCard);
